const wordList8_4 = [
  // Eigenschaften • Właściwości
  { pl: 'wygodny', de: 'bequem' },
  { pl: 'tani', de: 'billig' },
  { pl: 'korzystny dla środowiska', de: 'gut für die Umwelt' },
  { pl: 'wesoły', de: 'lustig' },
  { pl: 'praktyczny', de: 'praktisch' },
  { pl: 'nudny', de: 'langweilig' },
  { pl: 'niekorzystny dla środowiska', de: 'schlecht für die Umwelt' },
  { pl: 'drogi', de: 'teuer' },
  { pl: 'niewygodny', de: 'unbequem' },
  { pl: 'niepraktyczny', de: 'unpraktisch' },

  // Fahrplan • Rozkład jazdy
  { pl: 'odjeżdżać', de: 'abfahren' },
  { pl: 'odjazd', de: 'die Abfahrt' },
  { pl: 'startować, odlatywać', de: 'abfliegen' },
  { pl: 'odlot', de: 'der Abflug' },
  { pl: 'przyjeżdżać', de: 'ankommen' },
  { pl: 'przyjazd', de: 'die Ankunft' },
  { pl: 'trwać', de: 'dauern' },
  { pl: 'jazda', de: 'die Fahrt' },
  { pl: 'lot', de: 'der Flug' },

  // Fahrkarten • Bilety
  { pl: 'bilet na przejazd', de: 'die Fahrkarte' },
  { pl: 'bilet autobusowy', de: 'die Busfahrkarte' },
  { pl: 'bilet na pociąg', de: 'die Zugfahrkarte' },
  { pl: 'bilet na samolot', de: 'das Flugticket' },
  { pl: 'bilet jednorazowy', de: 'das Einzelticket' },

  // Höflichkeitsformeln • Grzeczne sformułowania
  { pl: 'Do zobaczenia później', de: 'Bis später' },
  { pl: 'Przepraszam', de: 'Entschuldigung' },
  { pl: 'Nie ma za co', de: 'Keine Ursache' },
  { pl: 'Nie wiem tego, przykro mi', de: 'Das weiß ich leider nicht, tut mir leid' },
  { pl: 'Dużo przyjemności w', de: 'Viel Spaß in' },
  { pl: 'Wielkie dzięki', de: 'Vielen Dank' },
  { pl: 'Pięknie / Świetnie', de: 'Wie schön' },

  // In der Stadt • W mieście
  { pl: 'dworzec', de: 'der Bahnhof' },
  { pl: 'oglądać, zwiedzać', de: 'besichtigen' },
  { pl: 'zwiedzać miasto', de: 'die Stadt besichtigen' },
  { pl: 'odwiedzać', de: 'besuchen' },
  { pl: 'katedra', de: 'der Dom' },
  { pl: 'rzeka', de: 'der Fluss' },
  { pl: 'przystanek', de: 'die Haltestelle' },
  { pl: 'dworzec główny', de: 'der Hauptbahnhof' },
  { pl: 'w pobliżu', de: 'in der Nähe' },
  { pl: 'kościół', de: 'die Kirche' },
  { pl: 'kiosk', de: 'der Kiosk' },
  { pl: 'rynek', de: 'der Markt' },
  { pl: 'muzeum', de: 'das Museum' },
  { pl: 'pasaż', de: 'die Passage' },
  { pl: 'plac', de: 'der Platz' },
  { pl: 'ulica', de: 'die Straße' },
  { pl: 'na ulicy', de: 'auf der Straße' },
  { pl: 'daleko od', de: 'weit von' },
  { pl: 'daleko (stąd)', de: 'weit weg' },
  { pl: 'zoo', de: 'der Zoo' },
  { pl: 'pieszo', de: 'zu Fuß' },
  { pl: 'iść pieszo', de: 'zu Fuß gehen' },

  // Nach dem Weg fragen • Pytanie o drogę
  { pl: 'prosto', de: 'geradeaus' },
  { pl: 'po lewej, w lewo', de: 'links' },
  { pl: 'iść w lewo', de: 'nach links gehen' },
  { pl: 'po prawej, w prawo', de: 'rechts' },
  { pl: 'iść w prawo', de: 'nach rechts gehen' },
  { pl: 'aplikacja nawigacyjna', de: 'die Navi-App' },
  { pl: 'plan miasta', de: 'der Stadtplan' },
  { pl: 'przez (np przez ulicę)', de: 'über' },
  { pl: 'przechodzić obok, mijać', de: 'vorbeigehen' },

  // Probleme • Problemy
  { pl: 'Bez paniki', de: 'Keine Panik' },
  { pl: 'mieć ból głowy', de: 'Kopfschmerzen haben' },
  { pl: 'zmęczony', de: 'müde' },
  { pl: 'rozumieć', de: 'verstehen' },
  { pl: 'Nie rozumiem', de: 'Ich verstehe nicht' },
  { pl: 'Co się dzieje', de: 'Was ist denn los' },

  // Verkehrsmittel • Środki transportu
  { pl: 'wysiadać', de: 'aussteigen' },
  { pl: 'wsiadać', de: 'einsteigen' },
  { pl: 'samochód', de: 'das Auto' },
  { pl: 'autobus', de: 'der Bus' },
  { pl: 'rower miejski', de: 'das City-Bike' },
  { pl: 'hulajnoga elektryczna', de: 'der E-Roller' },
  { pl: 'rower', de: 'das Fahrrad' },
  { pl: 'samolot', de: 'das Flugzeug' },
  { pl: 'lecieć samolotem', de: 'mit dem Flugzeug fliegen' },
  { pl: 'linia (autobusowa)', de: 'die Linie' },
  { pl: 'kolejka miejska', de: 'die S-Bahn' },
  { pl: 'tramwaj', de: 'die Straßenbahn' },
  { pl: 'taksówka', de: 'das Taxi' },
  { pl: 'metro', de: 'die U-Bahn' },
  { pl: 'pociąg', de: 'der Zug' },

  // Zeit • Czas
  { pl: 'wczoraj', de: 'gestern' },
  { pl: 'dzisiaj', de: 'heute' },
  { pl: 'jutro', de: 'morgen' },
];

export default wordList8_4;